require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./mail-coach-email-service.json") })
        }
      }, "path---mail-coach-email-service");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---mail-coach-email-service!./.cache/json/mail-coach-email-service.json
// module id = 282
// module chunks = 231608221292675